// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OCq756Dw6fA6nj4n7R6g {
	align-items: center;
	display: flex;
	gap: 10px;
	position: relative;
}

.uADMd9ZcLDkTTv7vpoak {
	position: absolute;
	left: -80px;
}

.YIriOwM60GElVCHybVwe {
	align-items: center;
	display: flex;
	flex: 1;
	margin: 0;
}

.hPbRUTfCGEDNWMYny6UB {
	color: var(--black);
	font-size: 32px;
	font-weight: 400;
	letter-spacing: -0.06em;
	line-height: 44px;
}

@media (--mobile) {

.hPbRUTfCGEDNWMYny6UB {
		font-size: 28px;
		line-height: 36px;
}
	}

.OAXSb0LX68_DJLkXK8JT {
	box-shadow: none;
}

.OAXSb0LX68_DJLkXK8JT:hover > svg {
		color: #5ce047;
	}

.Kk85l8ybG9NPCSE6Pasy {
	align-items: center;
	display: flex;
}

.KV6EmBIfrl2zyeox3234 {
	box-shadow: none;
}

.d4NrV8_GEY0QnzLd5mAJ {
	justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/components/PageHeader/PageHeader.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,aAAa;CACb,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,OAAO;CACP,SAAS;AACV;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,iBAAiB;AAMlB;;AAJC;;AAPD;EAQE,eAAe;EACf,iBAAiB;AAEnB;CADC;;AAGD;CACC,gBAAgB;AAKjB;;AAHC;EACC,cAAc;CACf;;AAGD;CACC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;AAC/B","sourcesContent":[".container {\n\talign-items: center;\n\tdisplay: flex;\n\tgap: 10px;\n\tposition: relative;\n}\n\n.arrowButton {\n\tposition: absolute;\n\tleft: -80px;\n}\n\n.content {\n\talign-items: center;\n\tdisplay: flex;\n\tflex: 1;\n\tmargin: 0;\n}\n\n.title {\n\tcolor: var(--black);\n\tfont-size: 32px;\n\tfont-weight: 400;\n\tletter-spacing: -0.06em;\n\tline-height: 44px;\n\n\t@media (--mobile) {\n\t\tfont-size: 28px;\n\t\tline-height: 36px;\n\t}\n}\n\n.question {\n\tbox-shadow: none;\n\n\t&:hover > svg {\n\t\tcolor: #5ce047;\n\t}\n}\n\n.rightContent {\n\talign-items: center;\n\tdisplay: flex;\n}\n\n.crossButton {\n\tbox-shadow: none;\n}\n\n.withoutRight {\n\tjustify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OCq756Dw6fA6nj4n7R6g`,
	"arrowButton": `uADMd9ZcLDkTTv7vpoak`,
	"content": `YIriOwM60GElVCHybVwe`,
	"title": `hPbRUTfCGEDNWMYny6UB`,
	"question": `OAXSb0LX68_DJLkXK8JT`,
	"rightContent": `Kk85l8ybG9NPCSE6Pasy`,
	"crossButton": `KV6EmBIfrl2zyeox3234`,
	"withoutRight": `d4NrV8_GEY0QnzLd5mAJ`
};
export default ___CSS_LOADER_EXPORT___;
